export default __webpack_public_path__ + "static/media/clean_general_new.69f7ea80.png";